import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
var _excluded = ["value", "onChange", "isDisabled"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import useUniqueId from 'hooks/useUniqueId';
import FormField from 'components/FormField';
import Flex, { Box } from 'components/Flex';
import CheckboxOption from 'components/CheckboxOption';
import Button from 'components/Button';
import ContentContributionsModal from 'screens/ContentContributionModal';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function MemberContributionsInfoButton(_ref) {
  var labelId = _ref.labelId;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isContentContributionModalOpen = _useState2[0],
    setContentContributionModalOpen = _useState2[1];
  return /*#__PURE__*/_jsxs(Box, {
    children: [/*#__PURE__*/_jsx(Button, {
      icon: "info",
      variant: "transparent",
      onClick: function onClick() {
        return setContentContributionModalOpen(true);
      },
      size: "small",
      "aria-describedby": labelId,
      children: t('actions_info')
    }), isContentContributionModalOpen && /*#__PURE__*/_jsx(ContentContributionsModal, {
      onClose: function onClose() {
        return setContentContributionModalOpen(false);
      }
    })]
  });
}
export function MemberContributionsCheckbox(_ref2) {
  var isDisabled = _ref2.isDisabled,
    _ref2$checked = _ref2.checked,
    checked = _ref2$checked === void 0 ? false : _ref2$checked,
    id = _ref2.id,
    onChange = _ref2.onChange;
  var _useTranslation2 = useTranslation(),
    t = _useTranslation2.t;
  return /*#__PURE__*/_jsxs(Flex, {
    align: "top",
    children: [/*#__PURE__*/_jsx(Box, {
      grow: true,
      shrink: true,
      mr: "auto",
      children: /*#__PURE__*/_jsx(CheckboxOption, {
        label: t('hint_member_contributions'),
        checked: checked,
        onChange: onChange,
        id: id,
        disabled: isDisabled
      })
    }), !isDisabled && /*#__PURE__*/_jsx(MemberContributionsInfoButton, {
      labelId: id
    })]
  });
}
function MemberContributionsField(_ref3) {
  var value = _ref3.value,
    onChange = _ref3.onChange,
    isDisabled = _ref3.isDisabled,
    otherProps = _objectWithoutProperties(_ref3, _excluded);
  var _useTranslation3 = useTranslation(),
    t = _useTranslation3.t;
  var checkboxId = useUniqueId();
  return /*#__PURE__*/_jsx(FormField, _objectSpread(_objectSpread({
    as: "span",
    label: t('form_user_created_assets')
  }, otherProps), {}, {
    children: /*#__PURE__*/_jsx(MemberContributionsCheckbox, {
      isDisabled: isDisabled,
      checked: value,
      id: checkboxId,
      onChange: onChange
    })
  }));
}
export default MemberContributionsField;